import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * 🔴 tailwind-merge has to be told about our type scale.
 *
 * Our font sizes are named (`text-body`, `text-title`, `text-display-l`…) rather than t-shirt
 * sizes. Out of the box tailwind-merge only recognises t-shirt sizes as font sizes, so it fell
 * through to its catch-all `text-color` group and treated `text-body` as a COLOUR — which put it
 * in conflict with `text-signal-fg` and silently dropped whichever came first.
 *
 * The symptom was every primary button on the site rendering its label in inherited ink on the
 * green fill instead of white. Registering the scale here fixes it for every component at once.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: ["micro", "caption", "body", "body-l", "title", "display-l", "display-xl"],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
